import { render, staticRenderFns } from "./WorkSpace.vue?vue&type=template&id=0a56b5e5&scoped=true"
import script from "./WorkSpace.vue?vue&type=script&lang=js"
export * from "./WorkSpace.vue?vue&type=script&lang=js"
import style0 from "./WorkSpace.vue?vue&type=style&index=0&id=0a56b5e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a56b5e5",
  null
  
)

export default component.exports